import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IPostingsWithWidgetAndTotalCountQuery } from 'app/library/posting/interfaces/interfaces/postings-with-widget-and-total-count.query.interface';
import { PostingsWithWidgetAndTotalCount } from 'app/library/posting/models/postings-with-widget-and-total-count.model';
import { PostingsWithWidget } from 'app/library/posting/models/postings-with-widget.model';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { map } from 'rxjs/operators';
import { IExperienceAlumniWidgetContentQuery } from '../interfaces/experience-alumni-widget-content.interface';
import { IExperienceConfigQuery } from '../interfaces/experience-config.interface';
import { IExperienceCustomWidgetContentQuery } from '../interfaces/experience-custom-widget-content.interface';
import { IExperienceWidgetContentQuery } from '../interfaces/experience-widget-content.interface';
import { IHeaderBannerContentPreviewQuery } from '../interfaces/header-banner-conent-preview.query.interface';
import { IStudentWidgetContentQuery } from '../interfaces/student-widget-content.interface';
import { ExperienceAlumniWidgetContent } from '../models/experience-alumni-widget-content.model';
import { ExperienceConfig } from '../models/experience-config.model';
import { ExperienceCustomWidgetContent } from '../models/experience-custom-widget-content.model';
import { ExperienceWidgetContent } from '../models/experience-widget-content.model';
import { HeaderBannerContentPreview } from '../models/header-banner-content-preview.model';
import { StudentWidgetContent } from '../models/student-widget-content.model';
import { Observable } from 'rxjs';

@Injectable()
export class EngageHomePageApiService {
    growHomePageSearchTerm: string;

    constructor(private _http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) public environment: IEnvironment) {}

    async getExperienceConfig(): Promise<ExperienceConfig> {
        return this._http
            .get<IExperienceConfigQuery>(`${this.environment.apiUrl}/engage/home-screen/config`)
            .pipe(map((query) => new ExperienceConfig(query)))
            .toPromise();
    }

    async getHeaderBannerContentPreview(): Promise<HeaderBannerContentPreview> {
        return this._http
            .get<IHeaderBannerContentPreviewQuery>(`${this.environment.apiUrl}/engage/home-screen/header-banner`)
            .pipe(map((query) => new HeaderBannerContentPreview(query)))
            .toPromise();
    }

    async getHomeScreenWidgets(): Promise<{ id: number; name: string }[]> {
        return this._http.get<{ id: number; name: string }[]>(`${this.environment.apiUrl}/engage/home-screen/widgets`).toPromise();
    }

    async searchPostings(search: string = '', widgetTypeId: number, postingType: string[]): Promise<PostingsWithWidgetAndTotalCount> {
        let params = new HttpParams();

        if (search) {
            params = params.set('query', search);
        }

        if (widgetTypeId) {
            params = params.set('filter[widget]', widgetTypeId);
        }

        if (postingType.length) {
            params = params.set('filter[type]', postingType.toString());
        }

        return this._http
            .get<IPostingsWithWidgetAndTotalCountQuery>(`${this.environment.apiUrl}/engage/home-screen/search`, { params })
            .pipe(map((queries) => new PostingsWithWidgetAndTotalCount(queries)))
            .toPromise();
    }

    getExperienceWidget(id: string): Observable<ExperienceWidgetContent> {
        return this._http.get<IExperienceWidgetContentQuery>(`${this.environment.apiUrl}/engage/home-screen/widget/${id}`).pipe(map((query) => new ExperienceWidgetContent(query)));
    }

    getExperienceCustomWidget(id: string): Observable<ExperienceCustomWidgetContent> {
        return this._http
            .get<IExperienceCustomWidgetContentQuery>(`${this.environment.apiUrl}/engage/home-screen/widget/${id}`)
            .pipe(map((query) => new ExperienceCustomWidgetContent(query)));
    }

    getExperienceAlumniWidgets(id: string): Observable<ExperienceAlumniWidgetContent> {
        return this._http
            .get<IExperienceAlumniWidgetContentQuery>(`${this.environment.apiUrl}/engage/home-screen/widget/${id}`)
            .pipe(map((query) => new ExperienceAlumniWidgetContent(query)));
    }

    getExperienceFeaturedWidget(id: string): Observable<ExperienceWidgetContent> {
        return this._http.get<IExperienceWidgetContentQuery>(`${this.environment.apiUrl}/engage/home-screen/widget/${id}`).pipe(map((query) => new ExperienceWidgetContent(query)));
    }

    getStudentWidget(id: string): Observable<StudentWidgetContent> {
        return this._http.get<IStudentWidgetContentQuery>(`${this.environment.apiUrl}/engage/home-screen/widget/${id}`).pipe(map((query) => new StudentWidgetContent(query)));
    }
}
